'use client';

import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const onGrvTheme = (e) => {
      const t = e?.detail?.theme;
      if (t === 'light' || t === 'dark') setTheme(t);
    };
    window.addEventListener('grv-theme', onGrvTheme);
    return () => window.removeEventListener('grv-theme', onGrvTheme);
  }, []);

  useEffect(() => {
    const stored = window.localStorage.getItem('grv-theme');
    if (stored === 'light' || stored === 'dark') {
      setTheme(stored);
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    root.classList.remove('light', 'dark', 'grv-light', 'grv-dark');
    root.classList.add(theme === 'light' ? 'grv-light' : 'grv-dark');
    window.localStorage.setItem('grv-theme', theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div
        id="grv-theme-root"
        className={
          theme === 'light'
            ? 'grv-light min-h-full flex flex-1 flex-col'
            : 'grv-dark min-h-full flex flex-1 flex-col'
        }
        data-theme={theme}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
